// extracted by mini-css-extract-plugin
export default {"inputsContainer":"EditFrequencyBandModal_inputsContainer__I2eX4","linkIcon":"EditFrequencyBandModal_linkIcon__cJHoW"};